import { combineReducers } from '@reduxjs/toolkit';

import { reducer as notification } from './notification';
import { reducer as app } from './app';
import { reducer as menu } from './menu';
import { reducer as drawer } from './drawer';

export default combineReducers({ notification, app, menu, drawer });
